import { v4 as uuid } from 'uuid';

const getUniqueKey = () => uuid();

export default getUniqueKey;
